import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

export default function useDocumentTitle(page) {
  const { tenant } = useAuth();
  useEffect(() => {
    const brand = tenant?.name || "InteriorOS";
    document.title = page ? `${page} · ${brand}` : brand;
  }, [tenant?.name, page]);
}
